const sort = document.querySelector('.js-sort');

if(sort) {
    sort.addEventListener('change', () => {
        Shopify.queryParams = {};
        if (location.search.length) {
            let params = location.search.substr(1).split('&');

            for (let i=0; i < params.length; i++) {
                let keyValue = params[i].split('=');

                if (keyValue.length) {
                    Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
                }
            }
        }

        Shopify.queryParams.sort_by = sort.value;
        location.search = decodeURIComponent(new URLSearchParams(Shopify.queryParams).toString());
    });
}
